import { format, getTime, formatDistanceToNow } from "date-fns-jalali";

// ----------------------------------------------------------------------

type DateTypes = string | number | Date;

export function fDate(date: DateTypes): string {
  return format(new Date(date), "dd MMMM yyyy");
}
export function fDateTime(date: DateTypes): string {
  return format(new Date(date), "HH:mm, dd MMMM yyyy");
}

export function fTimestamp(date: DateTypes): number {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date: DateTypes): string {
  return format(new Date(date), "dd/MM/yyyy hh:mm p");
}

export function fToNow(date: DateTypes): string {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}

export function fDay(date: DateTypes): string {
  return format(new Date(date), "dd");
}
export function fWeekDay(date: DateTypes): string {
  return format(new Date(date), "EEEE");
}
export function getMonthName(date: DateTypes): string {
  return format(new Date(date), "MMMM");
}
